import { CouponTypeCode, UserLevel } from "project-config/constants";
import CloseIcon from "@/assets/icons/topup/close";
import CheckIcon from "@/assets/icons/topup/renderbus-check";

export interface AnimationVipDescProps {
  [key: number]: string;
}

export const AnimationVipDesc: AnimationVipDescProps = {
  [UserLevel.Normal]: "user_basic_level_normal_user",
  [UserLevel.Sliver]: "user_basic_level_silver_user",
  [UserLevel.Gold]: "user_basic_level_gold_user",
  [UserLevel.Platinum]: "user_basic_level_platinum_user",
  [UserLevel.Diamond]: "user_basic_level_diamond_user",
};

export const enum QingCloudName {
  CPUCloud = "cpu-qingyun",
  GPUCloud = "gpu-qingyun",
}

export enum DesktopRechargeTab {
  Desktop = "desktop-recharge",
}

export enum BalanceWelfareType {
  balance = 1,
  UpGradeVip = 2,
}
export enum ExtraWelfareType {
  GPU = CouponTypeCode.GPU,
  CPU = CouponTypeCode.CPU,
  Universal = CouponTypeCode.Universal,
  CPUQingCloud = CouponTypeCode.CPUQingCloud,
  GPUQingCloud = CouponTypeCode.GPUQingCloud,
  LuckyDrawGift = 5,
  Desktop = CouponTypeCode.Desktop,
}

export enum TipType {
  NotSatisfied = "Not satisfied",
  Satisfied = "Satisfied",
}

type TipTypeProp = {
  icon: React.ReactElement;
  preTitle: string;
  bgColor: string;
  titleColor: string;
};

export const CouponCodeTipList: Record<TipType, TipTypeProp> = {
  [TipType.NotSatisfied]: {
    icon: <CloseIcon />,
    preTitle: "renderbus_coupon_tip_not_satisfide",
    bgColor: "#2F3238",
    titleColor: "#FFFFFF",
  },
  [TipType.Satisfied]: {
    icon: <CheckIcon />,
    preTitle: "renderbus_coupon_tip_satisfide",
    bgColor: "rgba(19, 203, 117, 0.1)",
    titleColor: "#13CB75",
  },
};
